import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import { motion, useInView } from "framer-motion";

const catalogItems = [
  { to: "/catalogue/evenement", label: "Évènement" },
  { to: "/catalogue/shooting", label: "Shooting" },
  { to: "/catalogue/drone", label: "Drone" },
  { to: "/catalogue/argentique", label: "Argentique" },
  { to: "/catalogue/nature", label: "Nature" },
  { to: "/catalogue/manifestation", label: "Manifestation" },
];

const Catalogue = () => {
  const listRef = useRef(null);
  const isInView = useInView(listRef, { once: true, margin: "-50px 0px" });

  return (
    <main id="catalog">
      <ul id="concert-list" ref={listRef}>
        {catalogItems.map((item, index) => (
          <motion.li
            key={item.to}
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.1, ease: "easeOut" }}
            style={{ listStyle: "none" }}
          >
            <NavLink to={item.to} className="concert-link">{item.label}</NavLink>
            <div className="concert-separator" style={{opacity: index < catalogItems.length - 1 ? 0.3 : 0}} />
          </motion.li>
        ))}
      </ul>
    </main>
  );
};

export default Catalogue;
